import { render, staticRenderFns } from "./ResultPayment.vue?vue&type=template&id=6a3ec1be&scoped=true&"
import script from "./ResultPayment.vue?vue&type=script&lang=js&"
export * from "./ResultPayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a3ec1be",
  null
  
)

export default component.exports